import Vue from 'vue'
import Router from 'vue-router'
let url = require('@/../config/sysConfig')
//ログイン
import Login from '@/components/page/login.vue'
//ログイン2
import PasswordReset from '@/components/page/passwordReset.vue'
//パスワードリセット
import PasswordResetDeliver from '@/components/page/passwordResetDeliver.vue'
//ログイン
import Home from '@/components/page/home.vue'
//メニュー
import Top from '@/components/page/top.vue'
//k_0001_勤怠入力
import K_0001 from '@/module/page/k_0001'
//k_0002_勤怠詳細
import K_0002 from '@/module/page/k_0002'
//k_0003_スキル確認
import K_0003 from '@/module/page/k_0003'
//k_0005_問合せ
import K_0005 from '@/module/page/k_0005'
//k_0006_経費一覧
import K_0006 from '@/module/page/k_0006'
//k_0007_経費詳細
import K_0007 from '@/module/page/k_0007'
//k_0008_オフィス事務センター
import K_0008 from '@/module/page/k_0008'

//i_0001_プロフィール基本
import I_0001 from '@/module/page/i_0001'
//i_0002_本人確認書類申請
import I_0002 from '@/module/page/i_0002'
//i_0003_給与振込口座申請
import I_0003 from '@/module/page/i_0003'
//i_0004_緊急連絡先申請
import I_0004 from '@/module/page/i_0004'
import DialogAddress from '@/components/page/dialogAddress'
//i_0005_マイナンバー申請
import I_0005 from '@/module/page/i_0005'
//i_0006_マイナンバー
import I_0006 from '@/module/page/i_0006'
//i_0007_在留カード番号申請
import I_0007 from '@/module/page/i_0007'
//i_0008_マイカー通勤申請
import I_0008 from '@/module/page/i_0008'
//i_0009_本人確認書類選択
import I_0009 from '@/module/page/i_0009'
//i_0010_国籍確認
import I_0010 from '@/module/page/i_0010'
//i_0011_誓約・同意
import I_0011 from '@/module/page/i_0011'
//i_0012_初期ログイン_パスワード変更
import I_0012 from '@/module/page/i_0012'
//i_0013_マイカー通勤申請確認
import I_0013 from '@/module/page/i_0013'
//i_0014_初期トレーニング
import I_0014 from '@/module/page/i_0014'
//i_0015_有休一覧
import I_0015 from '@/module/page/i_0015'
//i_0016_有休詳細
import I_0016 from '@/module/page/i_0016'
//i_0017_お仕事紹介
import I_0017 from '@/module/page/i_0017'
import I_0018 from '@/module/page/i_0018'
import I_0019 from '@/module/page/i_0019'
import I_0020 from '@/module/page/i_0020'

//c_0001_契約照会 一覧
import C_0001 from '@/module/page/c_0001'
//c_0002_契約照会 詳細
import C_0002 from '@/module/page/c_0002'
//c_0003_労働条件通知書
import C_0003 from '@/module/page/c_0003'

// s_0001_出勤可能日申請
import S_0001 from '@/module/page/s_0001'

//d_0001_源泉徴収票
import D_0001 from '@/module/page/d_0001'

// p_0001_支給照会 一覧
import P_0001 from '@/module/page/p_0001'
// p_0002_支給照会 賃金詳細
import P_0002 from '@/module/page/p_0002'
// p_0003_支給照会 賃金内訳一覧
import P_0003 from '@/module/page/p_0003'
// p_0004_支給照会 賃金内訳詳細
import P_0004 from '@/module/page/p_0004'

// お知らせ一覧
import B_0001 from '@/module/page/b_0001'
// お知らせ詳細
import B_0002 from '@/module/page/b_0002'
// 作業量一覧
import W_0001 from '@/module/page/w_0001'
// 作業量詳細
import W_0002 from '@/module/page/w_0002'

// error
import K_Error from '@/components/page/error'

Vue.use(Router)

// メニュー配置
export default [
  { path: '/', redirect: url.routerUrl_Login },
  {
    path: url.routerUrl_Login, name: 'ログイン', component: Login,
    meta: {
      requireAuth: false,
    }
  },
  {
    path: '/Home',
    component: Home,
    children: [
      {
        path: url.routerUrl_Top,
        name: 'ホーム',
        component: Top
      },
      {
        path: url.routerUrl_PasswordReset,
        name: 'パスワードリセット',
        component: PasswordReset
      },
      {
        path: url.routerUrl_PasswordResetDeliver,
        name: 'PasswordResetDeliver',
        component: PasswordResetDeliver
      },
      {
        path: url.routerUrl_K0001,
        name: '勤怠入力',
        component: K_0001
      },
      {
        path: url.routerUrl_K0002,
        name: '勤怠詳細',
        component: K_0002
      },
      {
        path: url.routerUrl_K0003,
        name: 'スキル確認',
        component: K_0003
      },
      {
        path: url.routerUrl_K0005,
        name: '問合せ',
        component: K_0005
      },
      {
        path: url.routerUrl_K0006,
        name: '経費一覧',
        component: K_0006
      },
      {
        path: url.routerUrl_K0007,
        name: '経費詳細',
        component: K_0007
      },
      {
        path: url.routerUrl_K0008,
        name: 'オフィス事務センター',
        component: K_0008
      },
      {
        path: url.routerUrl_I0001,
        name: 'スタッフ基本情報',
        component: I_0001
      },
      {
        path: url.routerUrl_I0002,
        name: '本人確認書類申請',
        component: I_0002
      },
      {
        path: url.routerUrl_I0003,
        name: '給与振込口座申請',
        component: I_0003
      },
      {
        path: url.routerUrl_I0004,
        name: '緊急連絡先申請',
        component: I_0004
      },
      {
        path: url.routerUrl_DialogAddress,
        name: '共通住所',
        component: DialogAddress
      },
      {
        path: url.routerUrl_I0005,
        name: 'マイナンバー申請確認',
        component: I_0005
      },
      {
        path: url.routerUrl_I0006,
        name: 'マイナンバー申請',
        component: I_0006
      },
      {
        path: url.routerUrl_I0007,
        name: '在留カード番号申請',
        component: I_0007
      },
      {
        path: url.routerUrl_I0008,
        name: 'マイカー通勤･業務使用申請',
        component: I_0008
      },
      {
        path: url.routerUrl_I0009,
        name: '本人確認書類選択',
        component: I_0009
      },
      {
        path: url.routerUrl_I0010,
        name: '国籍確認',
        component: I_0010
      },
      {
        path: url.routerUrl_I0011,
        name: '告知書兼同意書及び誓約書',
        component: I_0011
      },
      {
        path: url.routerUrl_I0012,
        name: '初回ログイン',
        component: I_0012
      },
      {
        path: url.routerUrl_I0013,
        name: 'マイカー通勤･業務使用申請確認',
        component: I_0013
      },
      {
        path: url.routerUrl_I0014,
        name: '初期トレーニング',
        component: I_0014
      },
      {
        path: url.routerUrl_I0015,
        name: '有休一覧',
        component: I_0015
      },
      {
        path: url.routerUrl_I0016,
        name: '有休詳細',
        component: I_0016
      },
      {
        path: url.routerUrl_I0017,
        name: 'お仕事案内',
        component: I_0017
      },
      {
        path: url.routerUrl_I0018,
        name: 'お仕事選択',
        component: I_0018
      },
      {
        path: url.routerUrl_I0019,
        name: 'お仕事詳細',
        component: I_0019
      },
      {
        path: url.routerUrl_I0020,
        name: 'お仕事申請',
        component: I_0020
      },
      {
        path: url.routerUrl_C0001,
        name: '契約照会',
        component: C_0001
      },
      {
        path: url.routerUrl_C0002,
        name: '契約詳細',
        component: C_0002
      },
      {
        path: url.routerUrl_C0003,
        name: '労働条件通知書',
        component: C_0003
      },
      {
        path: url.routerUrl_S0001,
        name: 'スケジュール',
        component: S_0001
      },
      {
        path: url.routerUrl_D0001,
        name: '源泉徴収票',
        component: D_0001
      },
      {
        path: url.routerUrl_P0001,
        name: '給与照会',
        component: P_0001
      },
      {
        path: url.routerUrl_P0002,
        name: '給与明細',
        component: P_0002
      },
      {
        path: url.routerUrl_P0003,
        name: '賞与明細',
        component: P_0003
      },
      {
        path: url.routerUrl_P0004,
        name: '源泉明細',
        component: P_0004
      },
      {
        path: url.routerUrl_B0001,
        name: 'お知らせ一覧',
        component: B_0001
      },
      {
        path: url.routerUrl_B0002,
        name: 'お知らせ詳細',
        component: B_0002
      },
      {
        path: url.routerUrl_W0001,
        name: '作業量一覧',
        component: W_0001
      },
      {
        path: url.routerUrl_W0002,
        name: '作業量詳細',
        component: W_0002
      }
    ]
  },
  {
    path: url.routerUrl_Error,
    name: '勤怠Error画面',
    component: K_Error
  },
  {
    path: '*', redirect: url.routerUrl_Login,
  }
]



// WEBPACK FOOTER //
// ./src/base/router/index.js